import { DepartmentCategoryModel, PopularDepartmentCategoryModel } from '@/models/diagnosis/category';
import { ECategoryType } from '@/services/doctor/DiagnosisCategoryService';
import { ROUTES } from '@/types/common';
import Link from 'next/link';

interface Props {
  departmentCategories: DepartmentCategoryModel[];
  popularDepartmentCategories: PopularDepartmentCategoryModel[];
}
const DepartmentCategoriesInfo = (props: Props) => {
  return (
    <div className={'flex flex-col'}>
      <section className={'border-gray-50 border-t-0 border-r-0 border-b border-solid px-[24px] pt-[40px] pb-[20px]'}>
        <h2 className={'typography-ui-17sb text-gray-600'}>많이 찾는 과목</h2>
        <ul className={'mt-[20px] flex flex-wrap items-center gap-[8px]'}>
          {props.popularDepartmentCategories.map((category) => {
            return (
              <li key={`popular-treatment-category-${category.id}`}>
                <Link href={ROUTES.TELEMEDICINE.DOCTORS.buildPath(ECategoryType.Department, category.id)}>
                  <a className={'flex h-[36px] items-center rounded-[40px] bg-gray-30 px-[16px]'}>
                    <h3 className={'typography-ui-15m text-gray-700'}>{category.name}</h3>
                  </a>
                </Link>
              </li>
            );
          })}
        </ul>
      </section>
      <section>
        <ul className={'flex flex-col'}>
          {props.departmentCategories.map((departmentCategory) => {
            return (
              <li
                key={`treatment-category-${departmentCategory.id}`}
                className={'border-gray-50 border-b-[1px] border-solid'}
              >
                <Link href={ROUTES.TELEMEDICINE.DOCTORS.buildPath(ECategoryType.Department, departmentCategory.id)}>
                  <a className={'flex items-center justify-between p-[24px]'}>
                    <div>
                      <h3 className={'typography-ui-17sb mb-[4px] text-gray-700'}>{departmentCategory.name}</h3>
                      <p className={'typography-ui-15r text-gray-400'}>{departmentCategory.description}</p>
                    </div>
                    <img
                      src={departmentCategory.icon}
                      alt={departmentCategory.name}
                      className={'aspect-square w-[40px]'}
                    />
                  </a>
                </Link>
              </li>
            );
          })}
        </ul>
      </section>
    </div>
  );
};

export default DepartmentCategoriesInfo;
